import { Injectable } from '@angular/core';
import { IJob } from '../../../interfaces/jobs/job.model';
import { ApiService } from '../api/api.service';

@Injectable()
export class WorkHeadersService {
  constructor(private apiService: ApiService) {}

  createWorkHeader(workHeader: IJob): Promise<IJob> {
    return this.apiService
      .post(`v1/work-headers`, [workHeader])
      .then((r: IJob[]) => r[0]);
  }
}
